import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/style/responsive.scss";
import "./assets/style/font.scss";
import "./assets/style/width.scss";
import "./assets/style/height.scss";
import "./assets/style/style.scss";
import "./assets/style/custom.scss";

import { Route, Routes } from "react-router-dom";
import Auth from "./screens/Login/Auth";
import Layout from "./screens/Dashoboard/Layout";
import Dashboard from "./screens/Dashoboard/Dashboard";
import Roles from "./screens/Role/Roles";
import Role from "./screens/Role/Role";
import Admins from "./screens/Admin/Admins";
import AdminPage from "./screens/Admin/AdminPage";
import States from "./screens/State/States";
import State from "./screens/State/State";
import PrivateRoutes from "./redux/store/privateRoutes";
import Cities from "./screens/Cities/Cities";
import City from "./screens/Cities/City";
import Locations from "./screens/Locations/Locations";
import LocationPage from "./screens/Locations/Location";
import Users from "./screens/Users/Users";
import User from "./screens/Users/User";
import BookedRoomView from "./screens/BookedRooms/BookedRoomsView";
import PropertyRequest from "./screens/Property/PropertyRequest";
import PropertyRequestPage from "./screens/Property/PropertyRequestPage";
import PropertyRequestView from "./screens/Property/PropertyRequestView";
import PropertyList from "./screens/Property/PropertyList";
import PropertyView from "./screens/Property/PropertyView";
import FoodPackage from "./screens/Property/FoodPackage";
import TeamOuting from "./screens/Property/TeamOuting";
import FullBlock from "./screens/FullBlock/FullBlock";
import RoomBooking from "./screens/Room/RoomBooking";
import RoomService from "./screens/Room/RoomService";
import RoomPhase from "./screens/Room/RoomPhase";
import RoomCreate from "./screens/Room/RoomCreate";
import JustWalk from "./screens/Property/JustWalk";
import RoomEdit from "./screens/Room/RoomEdit";
import PropertiesOwnerView from "./screens/PropertiesOwner/PropertiesOwnerView";
import Block from "./screens/FullBlock/Block";
import BlockView from "./screens/FullBlock/BlockView";
import RoomView from "./screens/Room/RoomView";
import PropertyOwnerList from "./screens/PropertiesOwner/PropertyOwnerList";
import PropertyOwner from "./screens/PropertiesOwner/PropertyOwner";
import ReceptionistList from "./screens/Receptionist/ReceptionistList";
import Receptionist from "./screens/Receptionist/Receptionist";
import ReceptionView from "./screens/Receptionist/ReceptionView";
import MMCList from "./screens/MMC/MMCList";
import MCC from "./screens/MMC/MCC";
import RecommendationList from "./screens/Recommendation/RecommendationList";
import Recommendation from "./screens/Recommendation/Recommendation";
import SubscriptionCancelRequest from "./screens/Subscription/SubscriptionCancelRequest";
import RecommendationPropertyList from "./screens/Recommendation/RecommendationPropertyList";
import SubscriptionCanceledProperties from "./screens/Subscription/SubscriptionCanceledProperties";
import ReccomendationBookingList from "./screens/Recommendation/ReccomendationBookingList";
import SubscriptionList from "./screens/Subscription/SubscriptionList";
import ServicesList from "./screens/Services/ServicesList";
import Service from "./screens/Services/Service";
import HotelCategoryList from "./screens/HotelCategory/HotelCategoryList";
import HotelCategory from "./screens/HotelCategory/HotelCategory";
import TimingSlotList from "./screens/TimeSlot/TimingSlotList";
import TimingSlot from "./screens/TimeSlot/TimingSlot";
import RoomCategoryList from "./screens/Room/RoomCategoryList";
import RoomCategory from "./screens/Room/RoomCategory";
import RoomBookingList from "./screens/Room/RoomBookingList";
import TodayEarning from "./screens/TodayEarnings/TodayEarning";
import BookingCaneclled from "./screens/BookedRooms/BookingCaneclled";
import TipsList from "./screens/TodayEarnings/TipsList";
import UserSupport from "./screens/Support/UserSupport";
import OwnerSupport from "./screens/Support/OwnerSupport";
import ReceptionistSupport from "./screens/Support/ReceptionistSupport";
import TransactionList from "./screens/Transaction/TransactionList";
import TransactionView from "./screens/Transaction/TransactionView";
import CouponsList from "./screens/Coupons/CouponsList";
import Coupon from "./screens/Coupons/Coupon";
import TodayEarningView from "./screens/TodayEarnings/TodayEarningView";
import ReferralList from "./screens/Referral/ReferralList";
import ReferralView from "./screens/Referral/ReferralView";
import BannerList from "./screens/Banner/BannerList";
import BannerView from "./screens/Banner/BannerView";
import AmenityList from "./screens/Amenity/AmenityList";
import AmenityView from "./screens/Amenity/AmenityView";
import ReviewsList from "./screens/Reviews/ReviewsList";
import Reviews from "./screens/Reviews/Reviews";
import ReportPage from "./screens/Report/ReportPage";
import Wishlist from "./screens/Wishlist/Wishlist";
import WishlistView from "./screens/Wishlist/WishlistView";
import BankAccounts from "./screens/BankAccounts/BankAccounts";
import BankAccountView from "./screens/BankAccounts/BankAccountView";

const ReactRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Auth />} />
      <Route element={<PrivateRoutes />}>
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/role" element={<Role />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/states" element={<States />} />
          <Route path="/state" element={<State />} />
          <Route path="/cities" element={<Cities />} />
          <Route path="/city" element={<City />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/location" element={<LocationPage />} />
          <Route path="/users" element={<Users />} />
          <Route path="/user" element={<User />} />
          <Route path="/booked-rooms-view" element={<BookedRoomView />} />
          <Route path="/property-request-list" element={<PropertyRequest />} />
          <Route path="/property" element={<PropertyRequestPage />} />
          <Route
            path="/property-request-view"
            element={<PropertyRequestView />}
          />
          <Route path="/property-list" element={<PropertyList />} />
          <Route path="/property-view" element={<PropertyView />} />
          <Route path="/food-package" element={<FoodPackage />} />
          <Route path="/team-outing" element={<TeamOuting />} />
          <Route path="/just-walk" element={<JustWalk />} />
          <Route path="/full-block" element={<FullBlock />} />
          <Route path="/block" element={<Block />} />
          <Route path="/block-view" element={<BlockView />} />
          <Route path="/weekend-room-service" element={<RoomService />} />
          <Route path="/phase" element={<RoomPhase />} />
          <Route path="/room" element={<RoomCreate />} />
          <Route path="/room-edit" element={<RoomEdit />} />
          <Route path="/room-view" element={<RoomView />} />
          <Route
            path="/property-owner-view"
            element={<PropertiesOwnerView />}
          />
          <Route path="/property-owner-list" element={<PropertyOwnerList />} />
          <Route path="/property-owner" element={<PropertyOwner />} />
          <Route path="/receptionist-list" element={<ReceptionistList />} />
          <Route path="/receptionist" element={<Receptionist />} />
          <Route path="/receptionist-view" element={<ReceptionView />} />
          <Route path="/mcc-list" element={<MMCList />} />
          <Route path="/mcc" element={<MCC />} />
          <Route path="/recommendation-list" element={<RecommendationList />} />
          <Route path="/recommendation" element={<Recommendation />} />
          <Route
            path="/recommendation-property-list"
            element={<RecommendationPropertyList />}
          />
          <Route
            path="/subscription-cancel-list"
            element={<SubscriptionCancelRequest />}
          />
          <Route
            path="/property-subscription-cancel-list"
            element={<SubscriptionCanceledProperties />}
          />
          <Route
            path="/reccomendation-list"
            element={<ReccomendationBookingList />}
          />
          <Route
            path="/subscribed-property-list"
            element={<SubscriptionList />}
          />

          <Route path="/service-list" element={<ServicesList />} />
          <Route path="/service" element={<Service />} />
          <Route path="/hotel-category-list" element={<HotelCategoryList />} />
          <Route path="/hotel-category" element={<HotelCategory />} />
          <Route path="/timing-slot-list" element={<TimingSlotList />} />
          <Route path="/timing-slot" element={<TimingSlot />} />
          <Route path="/room-category-list" element={<RoomCategoryList />} />
          <Route path="/room-category" element={<RoomCategory />} />
          <Route path="/booked-rooms" element={<RoomBookingList />} />
          <Route path="/today-earnings" element={<TodayEarning />} />
          <Route path="/today-earning-view" element={<TodayEarningView />} />
          <Route path="/cancelled-bookings" element={<BookingCaneclled />} />
          <Route path="/tips-list" element={<TipsList />} />
          <Route path="/user-support-list" element={<UserSupport />} />
          <Route path="/owner-support-list" element={<OwnerSupport />} />
          <Route
            path="/receptionist-support-list"
            element={<ReceptionistSupport />}
          />
          <Route path="/transaction-list" element={<TransactionList />} />
          <Route path="/transaction-view" element={<TransactionView />} />
          <Route path="/coupon-list" element={<CouponsList />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route path="/referral-list" element={<ReferralList />} />
          <Route path="/referral-list-view" element={<ReferralView />} />
          <Route path="/banner-list" element={<BannerList />} />
          <Route path="/banner" element={<BannerView />} />
          <Route path="/amenity-list" element={<AmenityList />} />
          <Route path="/amenity" element={<AmenityView />} />
          <Route path="/review-list" element={<ReviewsList />} />
          <Route path="/review" element={<Reviews />} />
          <Route path="/report-generator-create" element={<ReportPage />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/wishlist-view" element={<WishlistView />} />
          <Route path="/bank-accounts" element={<BankAccounts />} />
          <Route path="/bank-accounts-view" element={<BankAccountView />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default ReactRoutes;
